export default {"src":"/_next/static/media/solana-sol-logo-white.274fd2e3.svg","height":16,"width":18};